import rootReducer from './reducers';
import { createStore } from 'redux';
import { syncHistoryWithStore } from 'react-router-redux';
import { hashHistory } from 'react-router';

const defaultState = {

}

let store;

if(process.env.NODE_ENV === 'production') {
    store = createStore(rootReducer);
}else{
    store = createStore(rootReducer,window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
}

export const history = syncHistoryWithStore(hashHistory,store);


export default store;



// WEBPACK FOOTER //
// ./store.js